import React from "react";
import logoWCE from "images/logo-wce.png";
import Button from "components/Button/Button";
import { lang } from "constant/lang";
import stars3 from "images/pattern/stars-3.svg";
import dotsBlue from "images/pattern/dots-blue.svg";
import { Link as LinkScroll } from "react-scroll";

const HeroSection = () => {
  return (
    <div className="w-full max-w-[1300px] mx-auto">
      <div className="flex flex-col md2:flex-row justify-between w-full gap-10">
        <div className="self-center max-w-[560px] z-20">
          <img
            className="w-full min-w-[327px]"
            src={logoWCE}
            alt={"WCE Logo"}
          />
        </div>
        <div className="flex justify-center z-10">
          <div className="relative w-fit">
            <div className="absolute -right-12 -top-8">
              <img
                className="w-[140px] min-w-[140px]"
                src={dotsBlue}
                alt={"dotsBlue"}
              />
            </div>
            <div className="absolute -left-12 -bottom-8">
              <img
                className="w-[140px] min-w-[140px]"
                src={dotsBlue}
                alt={"dotsBlue"}
              />
            </div>
            <div
              className="z-20 bg-wce-pink-light rounded-2xl border-2 border-white
                md2:min-w-[440px] w-full max-w-full xs:max-w-[520px] py-6 xs:py-[53px] px-8 shadow-wce-hard relative"
            >
              <div className="flex flex-col w-full px-auto text-sm xs:text-2xl">
                <span className="mb-2 xs:mb-4 text-wce-navy-dark bg-white px-4 py-2 rounded-2xl w-fit">
                  {lang.homepage.hero.title.we}
                  <span className="text-wce-pink-bright font-medium">
                    {lang.homepage.hero.title.you}
                  </span>
                  {lang.homepage.hero.title.part}
                </span>
                <span className="mb-4 xs:mb-6 text-wce-pink-bright bg-wce-yellow-light px-4 py-2 rounded-2xl w-fit font-medium">
                  {lang.homepage.hero.slogan}
                </span>
                <div>
                  <LinkScroll
                    to="events"
                    smooth={true}
                    offset={-100}
                    duration={500}
                  >
                    <Button rounded size="large" className={"w-32 xs:w-40"}>
                      Join Event
                    </Button>
                  </LinkScroll>
                </div>
                <div className="absolute -right-8 -top-10">
                  <img
                    className="w-[100px] md:w-[132px] md:min-w-[132px]"
                    src={stars3}
                    alt={"stars3"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
